import Parchment from 'parchment.js';

class TextBlot extends Parchment.Text { }

export default TextBlot;



// WEBPACK FOOTER //
// ./blots/text.js